export type SummaryPage = "timeline" | "consolidated" | "themes";

export type SessionViewResolution =
  | { kind: "default" }
  | { kind: "summary"; page: SummaryPage }
  | { kind: "redirect"; destination: "default" | "timeline" };

export function resolveSessionViewRoute(splat: string | undefined): SessionViewResolution {
  const suffix = (splat ?? "").replace(/^\/+|\/+$/g, "");
  if (!suffix) return { kind: "default" };
  if (suffix === "summaries") return { kind: "redirect", destination: "timeline" };
  if (suffix === "summaries/timeline") return { kind: "summary", page: "timeline" };
  if (suffix === "summaries/consolidated") return { kind: "summary", page: "consolidated" };
  if (suffix === "summaries/themes") return { kind: "summary", page: "themes" };
  return { kind: "redirect", destination: "default" };
}
